import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, of, throwError} from 'rxjs';
import {VerifiedOtpOptionsResponse} from '../models/verified-otp-options.model';
import {catchError, map} from 'rxjs/operators';
import {ValidationErrorResponse} from '../../shared/models/validation-error-response';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  private readonly serviceLayerHost;
  private readonly VERIFIED_OTP_OPTIONS_PATH = '/public/v1/dearborn/users/verified-otp-options';
  private readonly REQUEST_ONE_TIME_PASSWORD_PATH = '/public/v1/dearborn/users/one-time-password';
  private readonly VALIDATE_ONE_TIME_PASSWORD_PATH = '/public/v1/dearborn/users/validations/one-time-password';
  private readonly CHANGE_PASSWORD_PASSWORD_PATH = '/public/v1/dearborn/users/one-time-password/password';

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.serviceLayerHost = environment.serviceLayer.host[domainNameParserService.getState()];
  }

  getVerifiedOtpOptions(username: string): Observable<VerifiedOtpOptionsResponse> {
    return this.http.get<VerifiedOtpOptionsResponse>(this.getVerifiedOtpOptionsPath(username), {
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('userName', username)
    }).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Server returned error response. Details: ' + JSON.stringify(err));
        return throwError('Cannot parse response from SL server.');
      })
    );
  }

  requestOneTimePassword(username: string, otpOption: string, otpValue: string): Observable<void> {
    return this.http.post<void>(this.getRequestOneTimePasswordPath(), null, {
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('Content-type', 'application/json')
        .set('Cache-Control', 'no-cache')
        .set('userName', username)
        .set('otpOption', otpOption)
        .set('otpValue', otpValue)
    }).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Server returned error response. Details: ' + JSON.stringify(err));
        return throwError('Cannot parse response from SL server.');
      })
    );
  }

  validateOneTimePassword(username: string, oneTimePassword: string): Observable<ValidationErrorResponse> {
    return this.http.post<ValidationErrorResponse>(this.getValidateOneTimePasswordPath(), null, {
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('Content-type', 'application/json')
        .set('userName', username)
        .set('one-time-password', oneTimePassword)
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) {
          return of(JSON.parse(err.error.message));
        } else {
          console.error('Server returned error response. Details: ' + JSON.stringify(err));
          return throwError('Cannot parse response from SL server.');
        }
      })
    );
  }

  changePassword(username: string, oneTimePassword: string, newPassword: string): Observable<ValidationErrorResponse> {
    return this.http.post<ValidationErrorResponse>(this.getChangePasswordPath(), null, {
      headers: new HttpHeaders()
        .set('Accept', 'application/json')
        .set('Content-type', 'application/json')
        .set('userName', username)
        .set('otp', oneTimePassword)
        .set('newPassword', newPassword)
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 422) {
          return of(JSON.parse(err.error.message));
        } else {
          console.error('Server returned error response. Details: ' + JSON.stringify(err));
          return throwError('Cannot parse response from SL server.');
        }
      })
    );
  }

  private getChangePasswordPath(): string {
    // return this.serviceLayerHost + this.CHANGE_PASSWORD_PASSWORD_PATH;
    return "changePassword";
  }

  private getRequestOneTimePasswordPath(): string {
    // return this.serviceLayerHost + this.REQUEST_ONE_TIME_PASSWORD_PATH;
    return "sendOneTimePassword";
  }

  private getValidateOneTimePasswordPath(): string {
    // return this.serviceLayerHost + this.VALIDATE_ONE_TIME_PASSWORD_PATH;
    return "validateOneTimePassword";
  }

  private getVerifiedOtpOptionsPath(username: string): string {
    // return this.serviceLayerHost + this.VERIFIED_OTP_OPTIONS_PATH + '?userName=' + username;
    return "verifiedOtpOptions";
  }
}
